function buildGraph(fields) {
  const g = {}
  for (const field of fields) {
    const deps = [...(field.options.deps || [null])]
    deps.pop()
    for (const dep of deps) {
      if (g[dep]) {
        g[dep].push(field.key)
      } else {
        g[dep] = [field.key]
      }
    }
  }
  return g
}

function getInDegree(g, start) {
  const q = [start]
  const v = {}
  const result = {}
  while (q.length) {
    const head = q.shift()
    if (g[head]) {
      for (const t of g[head]) {
        result[t] = (result[t] || 0) + 1
        if (!v[t]) {
          q.push(t)
          v[t] = true
        }
      }
    }
  }
  return result
}

function topSort(g, inDegree, start) {
  const q = [start]
  const v = {}
  const result = []
  while (q.length) {
    const head = q.shift()
    if (g[head]) {
      for (const t of g[head]) {
        if (!v[t]) {
          if (inDegree[t] > 0) {
            --inDegree[t]
          }
          if (!inDegree[t]) {
            result.push(t)
            q.push(t)
            v[t] = true
          }
        }
      }
    }
  }
  return result
}

export default fields => {
  const g = buildGraph(fields)
  const result = {}
  for (const field of fields) {
    const inDegree = getInDegree(g, field.key)
    result[field.key] = topSort(g, inDegree, field.key)
  }
  return result
}



// WEBPACK FOOTER //
// ./packages/utils/parseDependency.js